import { render, staticRenderFns } from "./GoodsIndex.vue?vue&type=template&id=65c08db6&scoped=true&"
import script from "./GoodsIndex.vue?vue&type=script&lang=js&"
export * from "./GoodsIndex.vue?vue&type=script&lang=js&"
import style0 from "./GoodsIndex.vue?vue&type=style&index=0&id=65c08db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c08db6",
  null
  
)

export default component.exports